import {SignupRequest} from "../models/signup-request.model";
import {PageRequest} from "../models/page-request.model";

export class GetMessageListAction {
  static readonly type = '[Message] GetMessageListAction';
  constructor(public payload: PageRequest) {}
}
export class GetMessageAction {
  static readonly type = '[Message] GetMessageAction';
  constructor(public payload: SignupRequest) {}
}

